/**
 * useIntegratedMenuList.js — 내 통합 메뉴 목록 (/api/my/integrated-menus) (2026-10-01 분리·보강)
 *
 * 전에는 AdminLayout 이 화면을 옮길 때마다 받고, 실패하면 빈 목록으로 덮었다. 통합관리 작업 대상이 이 목록으로
 * 정해지면서 두 가지를 바꿨다.
 *   ① 한 번 받은 뒤의 실패는 마지막 목록을 유지한다 — 오류 한 번에 통합 모드가 꺼지고 사람이 튕기지 않게.
 *      처음부터 못 받으면 빈 목록(= 통합관리 칸 없음, fail-closed).
 *   ② refresh() — 통합 관리 홈·통합 메뉴 관리에서 만들기·고치기·지우기 뒤에 불러 사이드바·선택창을 바로 맞춘다
 *      (같은 주소에 머물러서 화면 이동으로는 다시 받지 않는다).
 * loaded — 첫 응답(성공·실패)이 왔는가. 통합 화면 들어가기 확인이 이 값을 기다린다(새로고침 때 잘못 튕기지 않게).
 */
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { apiClient } from '../../../api/apiClient';

export function useIntegratedMenuList(pathname) {
  const [state, setState] = useState({ list: [], loaded: false });
  const gotOnce = useRef(false);
  const seq = useRef(0);

  const refresh = useCallback(() => {
    const mine = ++seq.current;
    const failed = () => {
      if (mine !== seq.current || gotOnce.current) return;
      setState({ list: [], loaded: true });
    };
    return apiClient.get('/api/my/integrated-menus')
      .then((res) => {
        if (!(res.ok && Array.isArray(res.data?.list))) { failed(); return; }
        if (mine !== seq.current) return; // 더 나중 요청이 있다 — 그 결과를 쓴다
        gotOnce.current = true;
        setState({ list: res.data.list, loaded: true });
      })
      .catch(failed);
  }, []);

  useEffect(() => { refresh(); }, [pathname, refresh]);

  return useMemo(() => ({ ...state, refresh }), [state, refresh]);
}
